module.exports = __webpack_public_path__ + "img/理赔案例.a8713861.jpg";